import React from "react";
import Select from "react-select";
import { Offcanvas, Button, Row, Col } from "react-bootstrap";

const ProductFilter = ({ filters, setFilters, modelOptions, storageOptions, onApply }) => {
  const [show, setShow] = React.useState(false);

  // Common React-Select Styles for bootstrap consistency
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '8px',
      borderColor: '#e2e8f0',
      boxShadow: 'none',
      '&:hover': { borderColor: '#cbd5e1' }
    }),
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : "";
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleApply = () => {
    onApply();
    setShow(false);
  };

  return (
    <>
      <Button variant="outline-primary" size="sm" onClick={() => setShow(true)} className="d-flex align-items-center gap-2">
        <i className="bi bi-funnel-fill"></i> Filters
      </Button>

      <Offcanvas show={show} onHide={() => setShow(false)} placement="end" className="border-0 shadow-lg">
        <Offcanvas.Header closeButton className="bg-light">
          <Offcanvas.Title className="fw-bold text-primary">Filter Inventory</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-4">
          
          <div className="mb-4">
            <label className="form-label fw-bold text-muted small">Model</label>
            <Select
              name="model"
              options={modelOptions}
              placeholder="All Models"
              isClearable
              isSearchable
              onChange={handleSelectChange}
              styles={customStyles}
              value={modelOptions.find(opt => opt.value === filters.model) || null}
            />
          </div>
          <div className="mb-4">
            <label className="form-label fw-bold text-muted small">Storage</label>
            <Select
              name="storage"
              options={storageOptions}
              placeholder="All Storage"
              isClearable
              isSearchable
              onChange={handleSelectChange}
              styles={customStyles}
              value={storageOptions.find(opt => opt.value === filters.storage) || null}
            />
          </div>

          <hr className="text-muted opacity-25 my-4" />

          <div className="mb-3">
            <label className="form-label fw-bold text-muted small">Part Number</label>
            <input
              className="form-control"
              placeholder="Search..."
              name="partNumber"
              value={filters.partNumber || ""}
              onChange={handleInputChange}
            />
          </div>

          <Row className="g-3 mb-3">
            <Col xs={6}>
                <label className="form-label fw-bold text-muted small">OX</label>
                <input className="form-control" name="ox" value={filters.ox || ""} onChange={handleInputChange} />
            </Col>
            <Col xs={6}>
                <label className="form-label fw-bold text-muted small">NKI</label>
                <input className="form-control" name="nki" value={filters.nki || ""} onChange={handleInputChange} />
            </Col>
          </Row>

          <Row className="g-3 mb-4">
            <Col xs={6}>
                <label className="form-label fw-bold text-muted small">Price</label>
                <input type="number" className="form-control" name="price" value={filters.price || ""} onChange={handleInputChange} />
            </Col>
            <Col xs={6}>
                <label className="form-label fw-bold text-muted small">Height</label>
                <input type="number" className="form-control" name="height" value={filters.height || ""} onChange={handleInputChange} />
            </Col>
             <Col xs={6}>
                <label className="form-label fw-bold text-muted small">OD</label>
                <input type="number" className="form-control" name="od" value={filters.od || ""} onChange={handleInputChange} />
            </Col>
            <Col xs={6}>
                <label className="form-label fw-bold text-muted small">ID</label>
                <input type="number" className="form-control" name="id" value={filters.id || ""} onChange={handleInputChange} />
            </Col>
          </Row>

          <div className="d-grid">
            <button className="btn btn-primary py-2 fw-bold" onClick={handleApply}>
              Apply Filters
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ProductFilter;